export class SysexManufacturers
{
  // sysexData: Uint8Array
  // returns: number[]
  // Throws Error on invalid sysex.
  static getId(sysexData) {
    if (sysexData.length <= 3) // not a complete sysex
      throw new Error('Data is too short for a valid SysEx');

    // Manufacturer ID is 1 or 3 bytes following START_OF_SYSEX
    if (sysexData[1] === 0x00) {
      return [sysexData[1], sysexData[2], sysexData[3]];
    } else {
      return [sysexData[1]];
    }
  }

  // id: number[]
  // returns: string (or undefined if not found)
  static getName(id) {
    for (let [name, currid] of manufacturers) {
      if (id.length === currid.length &&
        id.every((v,i) => v === currid[i])) {
        return name;
      }
    }
    return undefined;
  }
}


// Compiled from the MIDI Manufacturers' Association data and
// various other sources, including:
// https://www.midi.org/specifications/item/manufacturer-id-numbers
// http://www.amei.or.jp/report/System_ID_e.html
// http://midi.teragonaudio.com/tech/midispec/id.htm
// (updated Aug 2017)
// TODO: Switch key/value for quick lookups by value?
var manufacturers = new Map([
  // Standard MIDI non-realtime messages
  ['MIDI', [0xf7]],

  // "Japanese group"
  ['Kawai', [0x40]],
  ['Roland', [0x41]],
  ['Korg', [0x42]],
  ['Yamaha', [0x43]],
  ['Casio', [0x44]],
  ['Kamiya', [0x46]],
  ['Akai', [0x47]],
  ['Victor', [0x48]],
  ['Fujitsu', [0x4b]],
  ['Sony', [0x4c]],
  ['Teac', [0x4e]],
  ['Matsushita Electric', [0x50]],
  ['Fostex', [0x51]],
  ['Zoom', [0x52]],
  ['Matsushita Comm', [0x54]],
  ['Suzuki', [0x55]],
  ['Fuji', [0x56]],
  ['Acoustic Technical Lab', [0x57]],
  ['Faith', [0x59]],
  ['Internet Corp', [0x5a]],
  ['Seekers', [0x5c]],
  ['SD Card Association', [0x5f]],
  ['Crimson', [0x00, 0x40, 0x00]],
  ['Softbank', [0x00, 0x40, 0x01]],
  ['D&M', [0x00, 0x40, 0x03]],
  ['Xing', [0x00, 0x40, 0x04]],
  ['Pioneer', [0x00, 0x40, 0x05]],

  // "North american group"
  ['Sequential / Dave Smith', [0x01]],
  ['IDP', [0x02]],
  ['Voyetra', [0x03]],
  ['Moog Music', [0x04]],
  ['Passport Designs', [0x05]],
  ['Lexicon', [0x06]],
  ['Kurzweil', [0x07]],
  ['Fender', [0x08]],
  ['Gulbransen', [0x09]],
  ['AKG Acoustics', [0x0a]],
  ['Voyce Music', [0x0b]],
  ['Waveframe', [0x0c]],
  ['ADA Signal Processors', [0x0d]],
  ['Garfield', [0x0e]],
  ['Ensoniq', [0x0f]],
  ['Oberheim / Gibson', [0x10]],
  ['Apple', [0x11]],
  ['Grey Matter', [0x12]],
  ['Digidesign', [0x13]],
  ['Palmtree', [0x14]],
  ['JLCooper', [0x15]],
  ['Lowrey', [0x16]],
  ['Adams-Smith', [0x17]],
  ['E-MU', [0x18]],
  ['Harmony Systems', [0x19]],
  ['ART', [0x1a]],
  ['Baldwin', [0x1b]],
  ['Eventide', [0x1c]],
  ['Inventronics', [0x1d]],
  ['Clarity', [0x1f]],
  ['Time Warner', [0x00, 0x00, 0x01]],
  ['Gravis', [0x00, 0x00, 0x02]],
  ['Media Vision', [0x00, 0x00, 0x03]],
  ['Dornes Research', [0x00, 0x00, 0x04]],
  ['K-Muse', [0x00, 0x00, 0x05]],
  ['Stypher', [0x00, 0x00, 0x06]],
  ['Digital Music', [0x00, 0x00, 0x07]],
  ['IOTA', [0x00, 0x00, 0x08]],
  ['New England Digital', [0x00, 0x00, 0x09]],
  ['Artisyn', [0x00, 0x00, 0x0a]],
  ['IVL Tech', [0x00, 0x00, 0x0b]],
  ['Southern Music Sys', [0x00, 0x00, 0x0c]],
  ['Lake Butler Sound', [0x00, 0x00, 0x0d]],
  ['Alesis', [0x00, 0x00, 0x0e]],
  ['Sound Creation', [0x00, 0x00, 0x0f]],
  ['DOD Electronics', [0x00, 0x00, 0x10]],
  ['Studer-Editech', [0x00, 0x00, 0x11]],
  ['Sonus', [0x00, 0x00, 0x12]],
  ['Temporal Acuity', [0x00, 0x00, 0x13]],
  ['Perfect Fretworks', [0x00, 0x00, 0x14]],
  ['KAT', [0x00, 0x00, 0x15]],
  ['Opcode Systems', [0x00, 0x00, 0x16]],
  ['Rane', [0x00, 0x00, 0x17]],
  ['Anadi', [0x00, 0x00, 0x18]],
  ['KMX', [0x00, 0x00, 0x19]],
  ['Allen & Heath', [0x00, 0x00, 0x1a]],
  ['Peavey', [0x00, 0x00, 0x1b]],
  ['360 System', [0x00, 0x00, 0x1c]],
  ['Spectrum Design', [0x00, 0x00, 0x1d]],
  ['Marquis Music', [0x00, 0x00, 0x1e]],
  ['Zeta Systems', [0x00, 0x00, 0x1f]],
  ['Axxes', [0x00, 0x00, 0x20]],
  ['Orban', [0x00, 0x00, 0x21]],
  ['Indian Valley', [0x00, 0x00, 0x22]],
  ['Triton', [0x00, 0x00, 0x23]],
  ['KTI', [0x00, 0x00, 0x24]],
  ['Breakaway', [0x00, 0x00, 0x25]],
  ['CAE', [0x00, 0x00, 0x26]],
  ['Harrison', [0x00, 0x00, 0x27]],
  ['Future Lab', [0x00, 0x00, 0x28]],
  ['Rocktron', [0x00, 0x00, 0x29]],
  ['PianoDisc', [0x00, 0x00, 0x2a]],
  ['Cannon Research', [0x00, 0x00, 0x2b]],
  ['Rodgers', [0x00, 0x00, 0x2d]],
  ['Blue Sky Logic', [0x00, 0x00, 0x2e]],
  ['Encore', [0x00, 0x00, 0x2f]],
  ['Uptown', [0x00, 0x00, 0x30]],
  ['Voce', [0x00, 0x00, 0x31]],
  ['CTI Audio', [0x00, 0x00, 0x32]],
  ['S&S Research', [0x00, 0x00, 0x33]],
  ['Broderbund', [0x00, 0x00, 0x34]],
  ['Allen Organ', [0x00, 0x00, 0x35]],
  ['Music Quest', [0x00, 0x00, 0x37]],
  ['Aphex', [0x00, 0x00, 0x38]],
  ['Gallien Krueger', [0x00, 0x00, 0x39]],
  ['IBM', [0x00, 0x00, 0x3a]],
  ['MOTU', [0x00, 0x00, 0x3b]],
  ['Hotz', [0x00, 0x00, 0x3c]],
  ['ETA Lighting', [0x00, 0x00, 0x3d]],
  ['NSI', [0x00, 0x00, 0x3e]],
  ['AdLib', [0x00, 0x00, 0x3f]],
  ['Richmond', [0x00, 0x00, 0x40]],
  ['Microsoft', [0x00, 0x00, 0x41]],
  ['Software Toolworks', [0x00, 0x00, 0x42]],
  ['Russ Jones', [0x00, 0x00, 0x43]],
  ['Intone', [0x00, 0x00, 0x44]],
  ['Advanced Remote Tech', [0x00, 0x00, 0x45]],
  ['GT Electronics', [0x00, 0x00, 0x47]],
  ['Timeline Vista', [0x00, 0x00, 0x49]],
  ['Mesa Boogie', [0x00, 0x00, 0x4a]],
  ['Sequoia', [0x00, 0x00, 0x4c]],
  ['Studio Electronics', [0x00, 0x00, 0x4d]],
  ['Euphonix', [0x00, 0x00, 0x4e]],
  ['InterMIDI', [0x00, 0x00, 0x4f]],
  ['MIDI Solutions', [0x00, 0x00, 0x50]],
  ['3DO', [0x00, 0x00, 0x51]],
  ['Lightwave Research', [0x00, 0x00, 0x52]],
  ['Micro-W', [0x00, 0x00, 0x53]],
  ['Spectral Synthesis', [0x00, 0x00, 0x54]],
  ['Lone Wolf', [0x00, 0x00, 0x55]],
  ['Studio Technologies', [0x00, 0x00, 0x56]],
  ['Peterson', [0x00, 0x00, 0x57]],
  ['Atari', [0x00, 0x00, 0x58]],
  ['Marion Systems', [0x00, 0x00, 0x59]],
  ['Design Event', [0x00, 0x00, 0x5a]],
  ['Winjammer', [0x00, 0x00, 0x5b]],
  ['AT&T Bell Labs', [0x00, 0x00, 0x5c]],
  ['Symetrix', [0x00, 0x00, 0x5e]],
  ['MIDI the World', [0x00, 0x00, 0x5f]],
  ['Desper', [0x00, 0x00, 0x60]],
  ['Micros \'n MIDI', [0x00, 0x00, 0x61]],
  ['Accordians Intl', [0x00, 0x00, 0x62]],
  ['EuPhonics', [0x00, 0x00, 0x63]],
  ['Musonix', [0x00, 0x00, 0x64]],
  ['Turtle Beach', [0x00, 0x00, 0x65]],
  ['Mackie', [0x00, 0x00, 0x66]],
  ['Compuserve', [0x00, 0x00, 0x67]],
  ['BEC', [0x00, 0x00, 0x68]],
  ['QRS Music Rolls', [0x00, 0x00, 0x69]],
  ['PG Music', [0x00, 0x00, 0x6a]],
  ['Sierra Semi', [0x00, 0x00, 0x6b]],
  ['EpiGraf', [0x00, 0x00, 0x6c]],
  ['Electronics Diversified', [0x00, 0x00, 0x6d]],
  ['Tune 1000', [0x00, 0x00, 0x6e]],
  ['AMD', [0x00, 0x00, 0x6f]],
  ['Mediamation', [0x00, 0x00, 0x70]],
  ['Sabine Musical', [0x00, 0x00, 0x71]],
  ['Woog Labs', [0x00, 0x00, 0x72]],
  ['Micropolis', [0x00, 0x00, 0x73]],
  ['Ta Horng Musical Instrument', [0x00, 0x00, 0x74]],
  ['e-Tek Labs (Forte Tech)', [0x00, 0x00, 0x75]],
  ['Electro-Voice', [0x00, 0x00, 0x76]],
  ['Midisoft Corporation', [0x00, 0x00, 0x77]],
  ['QSound Labs', [0x00, 0x00, 0x78]],
  ['Westrex', [0x00, 0x00, 0x79]],
  ['Nvidia', [0x00, 0x00, 0x7A]],
  ['ESS Technology', [0x00, 0x00, 0x7B]],
  ['Media Trix Peripherals', [0x00, 0x00, 0x7C]],
  ['Brooktree Corp', [0x00, 0x00, 0x7D]],
  ['Otari Corp', [0x00, 0x00, 0x7E]],
  ['Key Electronics, Inc.', [0x00, 0x00, 0x7F]],
  ['Shure Incorporated', [0x00, 0x01, 0x00]],
  ['AuraSound', [0x00, 0x01, 0x01]],
  ['Crystal Semiconductor', [0x00, 0x01, 0x02]],
  ['Conexant (Rockwell)', [0x00, 0x01, 0x03]],
  ['Silicon Graphics', [0x00, 0x01, 0x04]],
  ['M-Audio (Midiman)', [0x00, 0x01, 0x05]],
  ['PreSonus', [0x00, 0x01, 0x06]],
  ['Topaz Enterprises', [0x00, 0x01, 0x08]],
  ['Cast Lighting', [0x00, 0x01, 0x09]],
  ['Microsoft', [0x00, 0x01, 0x0A]],
  ['Sonic Foundry', [0x00, 0x01, 0x0B]],
  ['Line 6 (Fast Forward) (Yamaha)', [0x00, 0x01, 0x0C]],
  ['Beatnik Inc', [0x00, 0x01, 0x0D]],
  ['Van Koevering Company', [0x00, 0x01, 0x0E]],
  ['Altech Systems', [0x00, 0x01, 0x0F]],
  ['S & S Research', [0x00, 0x01, 0x10]],
  ['VLSI Technology', [0x00, 0x01, 0x11]],
  ['Chromatic Research', [0x00, 0x01, 0x12]],
  ['Sapphire', [0x00, 0x01, 0x13]],
  ['IDRC', [0x00, 0x01, 0x14]],
  ['Justonic Tuning', [0x00, 0x01, 0x15]],
  ['TorComp Research Inc.', [0x00, 0x01, 0x16]],
  ['Newtek Inc.', [0x00, 0x01, 0x17]],
  ['Sound Sculpture', [0x00, 0x01, 0x18]],
  ['Walker Technical', [0x00, 0x01, 0x19]],
  ['Digital Harmony (PAVO)', [0x00, 0x01, 0x1A]],
  ['InVision Interactive', [0x00, 0x01, 0x1B]],
  ['T-Square Design', [0x00, 0x01, 0x1C]],
  ['Nemesys Music Technology', [0x00, 0x01, 0x1D]],
  ['DBX Professional (Harman Intl)', [0x00, 0x01, 0x1E]],
  ['Syndyne Corporation', [0x00, 0x01, 0x1F]],
  ['Bitheadz', [0x00, 0x01, 0x20]],
  ['Cakewalk Music Software (Gibson)', [0x00, 0x01, 0x21]],
  ['Analog Devices', [0x00, 0x01, 0x22]],
  ['National Semiconductor', [0x00, 0x01, 0x23]],
  ['Boom Theory / Adinolfi Alternative Percussion', [0x00, 0x01, 0x24]],
  ['Virtual DSP Corporation', [0x00, 0x01, 0x25]],
  ['Antares Systems', [0x00, 0x01, 0x26]],
  ['Angel Software', [0x00, 0x01, 0x27]],
  ['St Louis Music', [0x00, 0x01, 0x28]],
  ['Passport Music Software LLC (Gvox)', [0x00, 0x01, 0x29]],
  ['Ashley Audio Inc.', [0x00, 0x01, 0x2A]],
  ['Vari-Lite Inc.', [0x00, 0x01, 0x2B]],
  ['Summit Audio Inc.', [0x00, 0x01, 0x2C]],
  ['Aureal Semiconductor Inc.', [0x00, 0x01, 0x2D]],
  ['SeaSound LLC', [0x00, 0x01, 0x2E]],
  ['U.S. Robotics', [0x00, 0x01, 0x2F]],
  ['Aurisis Research', [0x00, 0x01, 0x30]],
  ['Nearfield Research', [0x00, 0x01, 0x31]],
  ['FM7 Inc', [0x00, 0x01, 0x32]],
  ['Swivel Systems', [0x00, 0x01, 0x33]],
  ['Hyperactive Audio Systems', [0x00, 0x01, 0x34]],
  ['MidiLite (Castle Studios Productions)', [0x00, 0x01, 0x35]],
  ['Radikal Technologies', [0x00, 0x01, 0x36]],
  ['Roger Linn Design', [0x00, 0x01, 0x37]],
  ['TC-Helicon Vocal Technologies', [0x00, 0x01, 0x38]],
  ['Event Electronics', [0x00, 0x01, 0x39]],
  ['Sonic Network Inc', [0x00, 0x01, 0x3A]],
  ['Realtime Music Solutions', [0x00, 0x01, 0x3B]],
  ['Apogee Digital', [0x00, 0x01, 0x3C]],
  ['Classical Organs, Inc.', [0x00, 0x01, 0x3D]],
  ['Microtools Inc.', [0x00, 0x01, 0x3E]],
  ['Numark Industries', [0x00, 0x01, 0x3F]],
  ['Frontier Design Group, LLC', [0x00, 0x01, 0x40]],
  ['Recordare LLC', [0x00, 0x01, 0x41]],
  ['Starr Labs', [0x00, 0x01, 0x42]],
  ['Voyager Sound Inc.', [0x00, 0x01, 0x43]],
  ['Manifold Labs', [0x00, 0x01, 0x44]],
  ['Aviom Inc.', [0x00, 0x01, 0x45]],
  ['Mixmeister Technology', [0x00, 0x01, 0x46]],
  ['Notation Software', [0x00, 0x01, 0x47]],
  ['Mercurial Communications', [0x00, 0x01, 0x48]],
  ['Wave Arts', [0x00, 0x01, 0x49]],
  ['Logic Sequencing Devices', [0x00, 0x01, 0x4A]],
  ['Axess Electronics', [0x00, 0x01, 0x4B]],
  ['Muse Research', [0x00, 0x01, 0x4C]],
  ['Open Labs', [0x00, 0x01, 0x4D]],
  ['Guillemot Corp', [0x00, 0x01, 0x4E]],
  ['Samson Technologies', [0x00, 0x01, 0x4F]],
  ['Electronic Theatre Controls', [0x00, 0x01, 0x50]],
  ['Blackberry (RIM)', [0x00, 0x01, 0x51]],
  ['Mobileer', [0x00, 0x01, 0x52]],
  ['Synthogy', [0x00, 0x01, 0x53]],
  ['Lynx Studio Technology Inc.', [0x00, 0x01, 0x54]],
  ['Damage Control Engineering LLC', [0x00, 0x01, 0x55]],
  ['Yost Engineering, Inc.', [0x00, 0x01, 0x56]],
  ['Brooks & Forsman Designs LLC / DrumLite', [0x00, 0x01, 0x57]],
  ['Infinite Response', [0x00, 0x01, 0x58]],
  ['Garritan Corp', [0x00, 0x01, 0x59]],
  ['Plogue Art et Technologie, Inc', [0x00, 0x01, 0x5A]],
  ['RJM Music Technology', [0x00, 0x01, 0x5B]],
  ['Custom Solutions Software', [0x00, 0x01, 0x5C]],
  ['Sonarcana LLC / Highly Liquid', [0x00, 0x01, 0x5D]],
  ['Centrance', [0x00, 0x01, 0x5E]],
  ['Kesumo LLC', [0x00, 0x01, 0x5F]],
  ['Stanton (Gibson)', [0x00, 0x01, 0x60]],
  ['Livid Instruments', [0x00, 0x01, 0x61]],
  ['First Act / 745 Media', [0x00, 0x01, 0x62]],
  ['Pygraphics, Inc.', [0x00, 0x01, 0x63]],
  ['Panadigm Innovations Ltd', [0x00, 0x01, 0x64]],
  ['Avedis Zildjian Co', [0x00, 0x01, 0x65]],
  ['Auvital Music Corp', [0x00, 0x01, 0x66]],
  ['You Rock Guitar (was: Inspired Instruments)', [0x00, 0x01, 0x67]],
  ['Chris Grigg Designs', [0x00, 0x01, 0x68]],
  ['Slate Digital LLC', [0x00, 0x01, 0x69]],
  ['Mixware', [0x00, 0x01, 0x6A]],
  ['Social Entropy', [0x00, 0x01, 0x6B]],
  ['Source Audio LLC', [0x00, 0x01, 0x6C]],
  ['Ernie Ball / Music Man', [0x00, 0x01, 0x6D]],
  ['Fishman', [0x00, 0x01, 0x6E]],
  ['Custom Audio Electronics', [0x00, 0x01, 0x6F]],
  ['American Audio/DJ', [0x00, 0x01, 0x70]],
  ['Mega Control Systems', [0x00, 0x01, 0x71]],
  ['Kilpatrick Audio', [0x00, 0x01, 0x72]],
  ['iConnectivity', [0x00, 0x01, 0x73]],
  ['Fractal Audio', [0x00, 0x01, 0x74]],
  ['NetLogic Microsystems', [0x00, 0x01, 0x75]],
  ['Music Computing', [0x00, 0x01, 0x76]],
  ['Nektar Technology Inc', [0x00, 0x01, 0x77]],
  ['Zenph Sound Innovations', [0x00, 0x01, 0x78]],
  ['DJTechTools.com', [0x00, 0x01, 0x79]],
  ['Rezonance Labs', [0x00, 0x01, 0x7A]],
  ['Decibel Eleven', [0x00, 0x01, 0x7B]],
  ['CNMAT', [0x00, 0x01, 0x7C]],
  ['Media Overkill', [0x00, 0x01, 0x7D]],
  ['Confusion Studios', [0x00, 0x01, 0x7E]],
  ['moForte Inc', [0x00, 0x01, 0x7F]],
  ['Miselu Inc', [0x00, 0x02, 0x00]],
  ['Amelia\'s Compass LLC', [0x00, 0x02, 0x01]],
  ['Zivix LLC', [0x00, 0x02, 0x02]],
  ['Artiphon', [0x00, 0x02, 0x03]],
  ['Synclavier Digital', [0x00, 0x02, 0x04]],
  ['Light & Sound Control Devices LLC', [0x00, 0x02, 0x05]],
  ['Retronyms Inc', [0x00, 0x02, 0x06]],
  ['JS Technologies', [0x00, 0x02, 0x07]],
  ['Quicco Sound', [0x00, 0x02, 0x08]],
  ['A-Designs Audio', [0x00, 0x02, 0x09]],
  ['McCarthy Music Corp', [0x00, 0x02, 0x0A]],
  ['Denon DJ', [0x00, 0x02, 0x0B]],
  ['Keith Robert Murray', [0x00, 0x02, 0x0C]],
  ['Google', [0x00, 0x02, 0x0D]],
  ['ISP Technologies', [0x00, 0x02, 0x0E]],
  ['Abstrakt Instruments LLC', [0x00, 0x02, 0x0F]],
  ['Meris LLC', [0x00, 0x02, 0x10]],
  ['Sensorpoint LLC', [0x00, 0x02, 0x11]],
  ['Hi-Z Labs', [0x00, 0x02, 0x12]],
  ['Imitone', [0x00, 0x02, 0x13]],
  ['Intellijel Designs Inc.', [0x00, 0x02, 0x14]],
  ['Dasz Instruments Inc.', [0x00, 0x02, 0x15]],
  ['Remidi', [0x00, 0x02, 0x16]],
  ['Disaster Area Designs LLC', [0x00, 0x02, 0x17]],
  ['Universal Audio', [0x00, 0x02, 0x18]],
  ['Carter Duncan Corp', [0x00, 0x02, 0x19]],
  ['Essential Technology', [0x00, 0x02, 0x1A]],
  ['Cantux Research LLC', [0x00, 0x02, 0x1B]],
  ['Hummel Technologies', [0x00, 0x02, 0x1C]],
  ['Sensel Inc', [0x00, 0x02, 0x1D]],
  ['DBML Group ', [0x00, 0x02, 0x1E]],
  ['Madrona Labs', [0x00, 0x02, 0x1F]],
  ['Mesa Boogie', [0x00, 0x02, 0x20]],
  ['Effigy Labs', [0x00, 0x02, 0x21]],

  // "European & Others group"
  ['Passac', [0x20]],
  ['SIEL', [0x21]],
  ['Synthaxe', [0x22]],
  ['Stepp', [0x23]],
  ['Hohner', [0x24]],
  ['Twister', [0x25]],
  ['Solton', [0x26]],
  ['Jellinghaus', [0x27]],
  ['Southworth', [0x28]],
  ['PPG', [0x29]],
  ['JEN', [0x2a]],
  ['SS Logic Organ Systems', [0x2b]],
  ['P. Struven', [0x2c]],
  ['Neve', [0x2d]],
  ['Soundtracs', [0x2e]],
  ['Elka', [0x2f]],
  ['Dynacord', [0x30]],
  ['Intercontinental', [0x31]],
  ['Drawmer', [0x32]],
  ['Clavia', [0x33]],
  ['Audio Architecture', [0x34]],
  ['GeneralMusic', [0x35]],
  ['Cheetah', [0x36]],
  ['CTM', [0x37]],
  ['Simmons', [0x38]],
  ['Soundcraft', [0x39]],
  ['Steinberg', [0x3a]],
  ['Wersi', [0x3b]],
  ['AVAB Niethammer', [0x3c]],
  ['Digigram', [0x3d]],
  ['Waldorf', [0x3e]],
  ['Quasimidi', [0x3f]],
  ['Dream', [0x00, 0x20, 0x00]],
  ['Strand Lighting', [0x00, 0x20, 0x01]],
  ['Amek Systems', [0x00, 0x20, 0x02]],
  ['Casa Di Risparmio', [0x00, 0x20, 0x03]],
  ['Bohm', [0x00, 0x20, 0x04]],
  ['Syntec', [0x00, 0x20, 0x05]],
  ['Trident', [0x00, 0x20, 0x06]],
  ['Real World Audio', [0x00, 0x20, 0x07]],
  ['Evolution Synthesis', [0x00, 0x20, 0x08]],
  ['Yes', [0x00, 0x20, 0x09]],
  ['Audiomatica', [0x00, 0x20, 0x0a]],
  ['Bontempi / Farfisa', [0x00, 0x20, 0x0b]],
  ['FBT', [0x00, 0x20, 0x0c]],
  ['MidiTemp', [0x00, 0x20, 0x0d]],
  ['LA Audio', [0x00, 0x20, 0x0e]],
  ['Zero 88', [0x00, 0x20, 0x0f]],
  ['Micon Audio', [0x00, 0x20, 0x10]],
  ['Forefront', [0x00, 0x20, 0x11]],
  ['Studio AV', [0x00, 0x20, 0x12]],
  ['Kenton', [0x00, 0x20, 0x13]],
  ['Celco / Electrosonic', [0x00, 0x20, 0x14]],
  ['ADB', [0x00, 0x20, 0x15]],
  ['Marshall', [0x00, 0x20, 0x16]],
  ['DDA', [0x00, 0x20, 0x17]],
  ['BSS Audio', [0x00, 0x20, 0x18]],
  ['MA Lighting', [0x00, 0x20, 0x19]],
  ['Fatar', [0x00, 0x20, 0x1a]],
  ['Artisan Organ', [0x00, 0x20, 0x1c]],
  ['Orla Spa', [0x00, 0x20, 0x1d]],
  ['Pinnacle', [0x00, 0x20, 0x1e]],
  ['TC Electronics', [0x00, 0x20, 0x1f]],
  ['Doepfer', [0x00, 0x20, 0x20]],
  ['Creative', [0x00, 0x20, 0x21]],
  ['Seiyddo/Minami', [0x00, 0x20, 0x22]],
  ['Goldstar', [0x00, 0x20, 0x23]],
  ['Midisoft', [0x00, 0x20, 0x24]],
  ['Samick', [0x00, 0x20, 0x25]],
  ['Penny & Giles', [0x00, 0x20, 0x26]],
  ['Acorn', [0x00, 0x20, 0x27]],
  ['LSC Electronics', [0x00, 0x20, 0x28]],
  ['Focusrite/Novation', [0x00, 0x20, 0x29]],
  ['Samkyung Mechatronics', [0x00, 0x20, 0x2A]],
  ['Medeli Electronics Co.', [0x00, 0x20, 0x2B]],
  ['Charlie Lab SRL', [0x00, 0x20, 0x2C]],
  ['Blue Chip Music Technology', [0x00, 0x20, 0x2D]],
  ['BEE OH Corp', [0x00, 0x20, 0x2E]],
  ['LG Semicon America', [0x00, 0x20, 0x2F]],
  ['TESI', [0x00, 0x20, 0x30]],
  ['EMAGIC', [0x00, 0x20, 0x31]],
  ['Behringer GmbH', [0x00, 0x20, 0x32]],
  ['Access Music Electronics', [0x00, 0x20, 0x33]],
  ['Synoptic', [0x00, 0x20, 0x34]],
  ['Hanmesoft', [0x00, 0x20, 0x35]],
  ['Terratec Electronic GmbH', [0x00, 0x20, 0x36]],
  ['Proel SpA', [0x00, 0x20, 0x37]],
  ['IBK MIDI', [0x00, 0x20, 0x38]],
  ['IRCAM', [0x00, 0x20, 0x39]],
  ['Propellerhead Software', [0x00, 0x20, 0x3A]],
  ['Red Sound Systems Ltd', [0x00, 0x20, 0x3B]],
  ['Elektron ESI AB', [0x00, 0x20, 0x3C]],
  ['Sintefex Audio', [0x00, 0x20, 0x3D]],
  ['MAM (Music and More)', [0x00, 0x20, 0x3E]],
  ['Amsaro GmbH', [0x00, 0x20, 0x3F]],
  ['CDS Advanced Technology BV (Lanbox)', [0x00, 0x20, 0x40]],
  ['Mode Machines (Touched By Sound GmbH)', [0x00, 0x20, 0x41]],
  ['DSP Arts', [0x00, 0x20, 0x42]],
  ['Phil Rees Music Tech', [0x00, 0x20, 0x43]],
  ['Stamer Musikanlagen GmbH', [0x00, 0x20, 0x44]],
  ['Musical Muntaner S.A. dba Soundart', [0x00, 0x20, 0x45]],
  ['C-Mexx Software', [0x00, 0x20, 0x46]],
  ['Klavis Technologies', [0x00, 0x20, 0x47]],
  ['Noteheads AB', [0x00, 0x20, 0x48]],
  ['Algorithmix', [0x00, 0x20, 0x49]],
  ['Skrydstrup R&D', [0x00, 0x20, 0x4A]],
  ['Professional Audio Company', [0x00, 0x20, 0x4B]],
  ['NewWave Labs (MadWaves)', [0x00, 0x20, 0x4C]],
  ['Vermona', [0x00, 0x20, 0x4D]],
  ['Nokia', [0x00, 0x20, 0x4E]],
  ['Wave Idea', [0x00, 0x20, 0x4F]],
  ['Hartmann GmbH', [0x00, 0x20, 0x50]],
  ['Lion\'s Tracs', [0x00, 0x20, 0x51]],
  ['Analogue Systems', [0x00, 0x20, 0x52]],
  ['Focal-JMlab', [0x00, 0x20, 0x53]],
  ['Ringway Electronics (Chang-Zhou) Co Ltd', [0x00, 0x20, 0x54]],
  ['Faith Technologies (Digiplug)', [0x00, 0x20, 0x55]],
  ['Showworks', [0x00, 0x20, 0x56]],
  ['Manikin Electronic', [0x00, 0x20, 0x57]],
  ['1 Come Tech', [0x00, 0x20, 0x58]],
  ['Phonic Corp', [0x00, 0x20, 0x59]],
  ['Dolby Australia (Lake)', [0x00, 0x20, 0x5A]],
  ['Silansys Technologies', [0x00, 0x20, 0x5B]],
  ['Winbond Electronics', [0x00, 0x20, 0x5C]],
  ['Cinetix Medien und Interface GmbH', [0x00, 0x20, 0x5D]],
  ['A&G Soluzioni Digitali', [0x00, 0x20, 0x5E]],
  ['Sequentix Music Systems', [0x00, 0x20, 0x5F]],
  ['Oram Pro Audio', [0x00, 0x20, 0x60]],
  ['Be4 Ltd', [0x00, 0x20, 0x61]],
  ['Infection Music', [0x00, 0x20, 0x62]],
  ['Central Music Co. (CME)', [0x00, 0x20, 0x63]],
  ['genoQs Machines GmbH', [0x00, 0x20, 0x64]],
  ['Medialon', [0x00, 0x20, 0x65]],
  ['Waves Audio Ltd', [0x00, 0x20, 0x66]],
  ['Jerash Labs', [0x00, 0x20, 0x67]],
  ['Da Fact', [0x00, 0x20, 0x68]],
  ['Elby Designs', [0x00, 0x20, 0x69]],
  ['Spectral Audio', [0x00, 0x20, 0x6A]],
  ['Arturia', [0x00, 0x20, 0x6B]],
  ['Vixid', [0x00, 0x20, 0x6C]],
  ['C-Thru Music', [0x00, 0x20, 0x6D]],
  ['Ya Horng Electronic Co LTD', [0x00, 0x20, 0x6E]],
  ['SM Pro Audio', [0x00, 0x20, 0x6F]],
  ['OTO MACHINES', [0x00, 0x20, 0x70]],
  ['ELZAB S.A. (G LAB)', [0x00, 0x20, 0x71]],
  ['Blackstar Amplification Ltd', [0x00, 0x20, 0x72]],
  ['M3i Technologies GmbH', [0x00, 0x20, 0x73]],
  ['Gemalto (from Xiring)', [0x00, 0x20, 0x74]],
  ['Prostage SL', [0x00, 0x20, 0x75]],
  ['Teenage Engineering', [0x00, 0x20, 0x76]],
  ['Tobias Erichsen Consulting', [0x00, 0x20, 0x77]],
  ['Nixer Ltd', [0x00, 0x20, 0x78]],
  ['Hanpin Electron Co Ltd', [0x00, 0x20, 0x79]],
  ['MIDI-hardware R.Sowa', [0x00, 0x20, 0x7A]],
  ['Beyond Music Industrial Ltd', [0x00, 0x20, 0x7B]],
  ['Kiss Box B.V.', [0x00, 0x20, 0x7C]],
  ['Misa Digital Technologies Ltd', [0x00, 0x20, 0x7D]],
  ['AI Musics Technology Inc', [0x00, 0x20, 0x7E]],
  ['Serato Inc LP', [0x00, 0x20, 0x7F]],
  ['Limex', [0x00, 0x21, 0x00]],
  ['Kyodday (Tokai)', [0x00, 0x21, 0x01]],
  ['Mutable Instruments', [0x00, 0x21, 0x02]],
  ['PreSonus Software Ltd', [0x00, 0x21, 0x03]],
  ['Ingenico (was Xiring)', [0x00, 0x21, 0x04]],
  ['Fairlight Instruments Pty Ltd', [0x00, 0x21, 0x05]],
  ['Musicom Lab', [0x00, 0x21, 0x06]],
  ['Modal Electronics (Modulus/VacoLoco)', [0x00, 0x21, 0x07]],
  ['RWA (Hong Kong) Limited', [0x00, 0x21, 0x08]],
  ['Native Instruments', [0x00, 0x21, 0x09]],
  ['Naonext', [0x00, 0x21, 0x0A]],
  ['MFB', [0x00, 0x21, 0x0B]],
  ['Teknel Research', [0x00, 0x21, 0x0C]],
  ['Ploytec GmbH', [0x00, 0x21, 0x0D]],
  ['Surfin Kangaroo Studio', [0x00, 0x21, 0x0E]],
  ['Philips Electronics HK Ltd', [0x00, 0x21, 0x0F]],
  ['ROLI Ltd', [0x00, 0x21, 0x10]],
  ['Panda-Audio Ltd', [0x00, 0x21, 0x11]],
  ['BauM Software', [0x00, 0x21, 0x12]],
  ['Machinewerks Ltd.', [0x00, 0x21, 0x13]],
  ['Xiamen Elane Electronics', [0x00, 0x21, 0x14]],
  ['Marshall Amplification PLC', [0x00, 0x21, 0x15]],
  ['Kiwitechnics Ltd', [0x00, 0x21, 0x16]],
  ['Rob Papen', [0x00, 0x21, 0x17]],
  ['Spicetone OU', [0x00, 0x21, 0x18]],
  ['V3Sound', [0x00, 0x21, 0x19]],
  ['IK Multimedia', [0x00, 0x21, 0x1A]],
  ['Novalia Ltd', [0x00, 0x21, 0x1B]],
  ['Modor Music', [0x00, 0x21, 0x1C]],
  ['Ableton', [0x00, 0x21, 0x1D]],
  ['Dtronics ', [0x00, 0x21, 0x1E]],
  ['ZAQ Audio', [0x00, 0x21, 0x1F]],
  ['Muabaobao Education Technology Co Ltd', [0x00, 0x21, 0x20]],
  ['Flux Effects', [0x00, 0x21, 0x21]],
  ['Audiothingies (MCDA)', [0x00, 0x21, 0x22]],
  ['Retrokits', [0x00, 0x21, 0x23]],
  ['Morningstar FX Pte Ltd', [0x00, 0x21, 0x24]],
  ['Hotone Audio', [0x00, 0x21, 0x25]],
  ['Expressive', [0x00, 0x21, 0x26]],
  ['Expert Sleepers Ltd', [0x00, 0x21, 0x27]],
  ['Timecode-Vision Technology ', [0x00, 0x21, 0x28]],
  ['Hornberg Research GbR', [0x00, 0x21, 0x29]],
  ['Sonic Potions', [0x00, 0x21, 0x2A]],
  ['Audiofront', [0x00, 0x21, 0x2B]],
  ['Fred\'s Lab', [0x00, 0x21, 0x2C]],
  ['Audio Modeling', [0x00, 0x21, 0x2D]],
  ['C. Bechstein Digital GmbH', [0x00, 0x21, 0x2E]],
  ['Motas Electronics Ltd', [0x00, 0x21, 0x2F]]
]);



// WEBPACK FOOTER //
// ./src/sysexmanufacturers.js